import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { createContext, useContext, useEffect, useState } from "react";
import { getIsOnpremise } from "../../utils";
import { useLicenseDetails } from "./services";
import { PatientsContext } from "../Patients/PatientsContext";
import { get, sortBy } from "lodash";
import { useAuth } from "@qure/qure-auth";
export var LicenseContext = /*#__PURE__*/createContext({
  licenseDetails: [],
  alertDetails: {},
  stickyAlert: undefined
});

// LicenseContextProvider component
export var LicenseContextProvider = function LicenseContextProvider(props) {
  var _licenseDetails$, _licenseDetails$find;
  var children = props.children;
  var _useContext = useContext(PatientsContext),
    wsData = _useContext.wsData;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isLoggedIn = get(userInfo, ["authenticated"], false);
  var isOnpremise = getIsOnpremise();
  var _useLicenseDetails = useLicenseDetails(isLoggedIn && isOnpremise),
    licenseData = _useLicenseDetails.data;
  var _useState = useState([]),
    licenseDetails = _useState[0],
    setLicenseDetails = _useState[1];

  // Function to retrieve alert information based on license details
  function getAlertInformation(details) {
    var alertData = [];

    // Iterate through each license detail
    var _iterator = _createForOfIteratorHelper(details),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var obj = _step.value;
        var app_name = obj.app_name,
          license_type = obj.license_type,
          aggregate_details = obj.aggregate_details,
          is_license_started = obj.is_license_started;

        // Skip processing if the license has not started
        if (!is_license_started) continue;
        var isAlert = false;
        var isPopupVisible = false;
        var showAlertAtTop = false;
        var remainingPercentage = void 0;

        // Check alert conditions based on license type
        if (license_type === "CONT") {
          // Calculate remaining percentage of scans
          remainingPercentage = Math.floor(aggregate_details.total_scans_remaining / aggregate_details.total_scans * 100);

          // Set alert if remaining percentage is 20% or less
          isAlert = remainingPercentage <= 20;
          showAlertAtTop = remainingPercentage <= 10;

          // Show popup only if remaining percentage matches specific values (20%, 15%, or 10%)
          isPopupVisible = shouldTriggerPopup({
            remainingPercentage: remainingPercentage,
            license_type: license_type,
            app_name: app_name
          }); //[20, 15, 10].includes(remainingPercentage);
        } else if (license_type === "TIME") {
          var total_days_remaining = aggregate_details.total_days_remaining,
            total_days = aggregate_details.total_days;
          remainingPercentage = Math.floor(total_days_remaining / total_days * 100);

          // Determine threshold for remaining days based on total days
          var threshold = total_days < 180 ? 15 : 90;

          // Set alert if remaining days are within the threshold
          isAlert = total_days_remaining <= threshold;

          // Show popup for specific remaining days:
          // - 15 days if total_days < 180
          // - 90, 60, or 30 days if total_days >= 180
          isPopupVisible = shouldTriggerPopup({
            remainingPercentage: remainingPercentage,
            license_type: license_type,
            total_days_remaining: total_days_remaining,
            total_days: total_days,
            app_name: app_name
          });
          // (total_days < 180 && total_days_remaining === 15) ||
          // (total_days >= 180 && [90, 60, 30].includes(total_days_remaining));

          showAlertAtTop = total_days < 180 && total_days_remaining <= 15 || total_days >= 180 && total_days_remaining <= 30;
        } else if (license_type === "PETL") {
          isPopupVisible = false;
          isAlert = false;
          remainingPercentage = 100;
        }

        // If an alert is triggered, creating an alert object with the relevant details
        var _alertObj = _objectSpread({
          app_name: app_name,
          isPopupVisible: isPopupVisible,
          license_type: license_type,
          is_license_started: is_license_started,
          remainingPercentage: remainingPercentage,
          isAlert: isAlert,
          showAlertAtTop: showAlertAtTop
        }, aggregate_details);
        alertData.push(_alertObj);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    alertData = sortBy(alertData, "remainingPercentage");
    return alertData;
  }
  var shouldTriggerPopup = function shouldTriggerPopup(licenseDetails) {
    var _licenseAlertDismissed = localStorage.getItem("licenseAlertDismissed");
    var licenseAlertDismissed = _licenseAlertDismissed ? JSON.parse(_licenseAlertDismissed) : null;
    var remainingPercentage = licenseDetails.remainingPercentage,
      license_type = licenseDetails.license_type,
      _licenseDetails$total = licenseDetails.total_days_remaining,
      total_days_remaining = _licenseDetails$total === void 0 ? 0 : _licenseDetails$total,
      _licenseDetails$total2 = licenseDetails.total_days,
      total_days = _licenseDetails$total2 === void 0 ? 0 : _licenseDetails$total2,
      app_name = licenseDetails.app_name;
    if (!!licenseAlertDismissed && app_name === licenseAlertDismissed.app_name) {
      if (license_type === "CONT") {
        var dismissedPercentage = licenseAlertDismissed.remainingPercentage;
        if (remainingPercentage <= 15 && dismissedPercentage > 15 || remainingPercentage <= 10 && dismissedPercentage > 10 || remainingPercentage <= 0) {
          localStorage.removeItem("licenseAlertDismissed");
          licenseAlertDismissed = null;
        }
      } else if (license_type === "TIME") {
        var dismissedRemainingDays = licenseAlertDismissed.total_days_remaining;
        if (total_days_remaining <= 60 && dismissedRemainingDays > 60 || total_days_remaining <= 30 && dismissedRemainingDays > 30 || total_days_remaining <= 0) {
          localStorage.removeItem("licenseAlertDismissed");
          licenseAlertDismissed = null;
        }
      }
    }
    var showPopup = false;
    if (license_type === "CONT") {
      if (remainingPercentage <= 20 && remainingPercentage > 0 && (!licenseAlertDismissed || app_name !== licenseAlertDismissed.app_name)) {
        showPopup = true;
      }
    } else if (license_type === "TIME") {
      if (total_days > 180 && total_days_remaining <= 90 && total_days_remaining > 0 && !licenseAlertDismissed) {
        showPopup = true;
      }
    }
    return showPopup;
  };
  useEffect(function () {
    if (licenseData !== null && licenseData !== void 0 && licenseData.license_details) {
      var res = getAlertInformation(licenseData.license_details);
      setLicenseDetails(res);
    }
  }, [licenseData]);
  useEffect(function () {
    if (wsData && wsData.action === "license_details") {
      var licenseContent = wsData.content;
      if (licenseContent) {
        var res = getAlertInformation(licenseContent);
        setLicenseDetails(res);
      }
    }
  }, [wsData]);
  return /*#__PURE__*/React.createElement(LicenseContext.Provider, {
    value: {
      licenseDetails: licenseDetails,
      alertDetails: (_licenseDetails$ = licenseDetails === null || licenseDetails === void 0 ? void 0 : licenseDetails[0]) !== null && _licenseDetails$ !== void 0 ? _licenseDetails$ : {},
      stickyAlert: (_licenseDetails$find = licenseDetails.find(function (detail) {
        return detail.showAlertAtTop;
      })) !== null && _licenseDetails$find !== void 0 ? _licenseDetails$find : undefined
    }
  }, children);
};